import { customScrollMinimal, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const MarkdownA = styled.a`
  ${typographyV2.bodyBase}
  color: var(--text-primary);
`;

export const MarkdownTableContainer = styled.div`
  overflow: scroll;
  margin: 1em 0px;
  ${customScrollMinimal}
`;

export const MarkdownTable = styled.table`
  border-spacing: 1px;
  width: 100%;

  tr {
    background-color: var(--background-default);
  }

  td {
    border-bottom: 1px solid var(--border-soft);
  }

  tbody tr:hover {
    background-color: var(--surface-hover);
  }
`;
